import SimpleAutoComplete from './SimpleAutoComplete';

export default SimpleAutoComplete;
